import { Link } from "react-router-dom";
import Logo from "./Logo";

const menuLinks = [
  { label: "메인", to: "/" },
  { label: "입학안내", to: "/admission" },
  { label: "수업안내", to: "/classes" },
  { label: "시간표", to: "/schedule" },
  { label: "학원안내", to: "/about" },
];

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-primary-950 text-white">
      <div className="pointer-events-none absolute inset-0 grain-light opacity-40" />
      <div className="relative mx-auto max-w-content px-5 pt-14 md:px-8 md:pt-16">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo light />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/60">
              이름값 하는 수학, 성적으로 증명합니다. 초·중·고 전 학년 수학 전문,
              소수정예 밀착 관리로 학생 한 명 한 명의 성장을 책임집니다.
            </p>
            <div className="mt-6 space-y-2.5 text-sm text-white/70">
              <p className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-400" />
                <span className="font-label tracking-wide">02-002-2525</span>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-time-line text-primary-400" />
                평일 13:00 – 22:00 · 토 10:00 – 18:00
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-400" />
                서울특별시 서초구 반포대로 123, 4층
              </p>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="mb-4 font-heading text-xs font-bold tracking-[0.25em] text-primary-400">
              MENU
            </h4>
            <ul className="space-y-2.5">
              {menuLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="inline-block text-sm text-white/60 transition-colors hover:text-primary-400 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="mb-4 font-heading text-xs font-bold tracking-[0.25em] text-primary-400">
              CONSULT
            </h4>
            <p className="text-sm leading-relaxed text-white/60">
              학생의 현재 성적과 학습 성향을 진단한 뒤, 가장 적합한 반과 학습
              계획을 안내해 드립니다.
            </p>
            <Link
              to="/consult"
              className="group mt-5 inline-flex items-center gap-2 overflow-hidden rounded-full bg-primary-500 px-5 py-3 text-sm font-bold text-foreground-950 cursor-pointer"
            >
              상담신청 하기
              <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>

        <div className="mt-12 flex flex-col justify-between gap-3 border-t border-white/10 pt-6 font-label text-xs text-white/50 sm:flex-row">
          <p>© 2026 명불허전 수학학원. All rights reserved.</p>
          <p>이름값 하는 수학, 성적으로 증명합니다</p>
        </div>
      </div>

      <div className="relative select-none overflow-hidden pt-6">
        <p className="pointer-events-none -mb-4 text-center font-heading text-[6rem] font-black leading-none text-white/5 md:-mb-10 md:text-[15rem]">
          명불허전
        </p>
      </div>
    </footer>
  );
}